import { createHttpClient } from "./http";

export class UnidadeMedidaRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	async get(params) {
		try {
			const result = await this.axios.get("measurement-unit", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params: params
			});

			return result.data;
		} catch (error) {
			console.log(error);
			if(error.response?.status === 401) {
				window.location.href = "/";
				throw new Error("Usuário não autenticado.");
			}

			throw new Error("Erro ao carregar unidades de medida.");
		}
	}
}
